import DataNotFound from "components/particles/table/data-not-found";
import useUsers from "containers/user-management/useHooks";
import React, { FC, Fragment, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { concatPathWithBackendUrl } from "utils/helpers/urlHelper";

interface Props {
  hostId: any;
}

const CupOfGratitude: FC<Props> = ({ hostId }) => {
  const { getCogbyHostId } = useUsers();
  const [data, setData] = useState<any[]>([]);
  const { isLoading } = useSelector((state: any) => state.sharedReducer);

  const fetchCog = () => {
    getCogbyHostId(hostId, setData);
  };
  useEffect(() => {
    fetchCog();
  }, []);

  return (
    <div>
      <div className="mt-8">
        <div className="bg-white border-[0.3px] border-mediumGrayBorder rounded-lg p-8">
          <div className="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {data.map((item: any, index: number) => (
              <div
                key={index + 1}
                className="bg-dividerLightBg  border border-stokeLight rounded-[30px] p-6 flex flex-col items-center justify-center gap-2 text-center h-[322px]"
              >
                <div className="relative">
                  <img
                    src={
                      item?.image
                        ? concatPathWithBackendUrl(item?.image?.fileDownloadUri)
                        : ""
                    }
                    alt={item?.name}
                    className="w-[157px] h-[177px]"
                  />
                </div>

                <h3 className="text-primaryText text-2xl font-bold">
                  {item?.name}
                </h3>
                <span className="">{item?.price}$</span>
                <span className="">{item?.quantity} Times</span>
              </div>
            ))}
          </div>
          <Fragment>
            <DataNotFound show={!isLoading && !data.length} />
          </Fragment>
        </div>
      </div>
    </div>
  );
};

export default CupOfGratitude;
